import { Component, OnInit } from '@angular/core';
import {StoreService} from '../../services/store.service';
import {ScreenService} from '../../services/screen.service';

@Component({
  selector: 'page-top',
  templateUrl: './page-top.component.html'
})
export class PageTopComponent implements OnInit {

  name: string;

  constructor(public storeService: StoreService,
              public screenService: ScreenService) {
    // this.name = `${this.storeService.user?.firstName} ${this.storeService.user?.secondName.slice(0, 1)}.`;
  }

  ngOnInit(): void {
  }

  toggleSidebar() {
    this.storeService.actions.toggleSidebar();
  }
}
